/* validate.js */

const VALIDCHECK = {
	'number':
		(value, model) => {
			if (model.null && value === null)
				return true;
			if (typeof value !== 'number')
				return false;
			if (model.exceptions)
				if (model.exceptions.indexOf(value) > -1)
					return false;
			if (model.options)
				if (model.options.indexOf(value) == -1)
					return false;	
			return true;				
		},
	'int':
		(value, model) => {
			if (model.null && value === null)
				return true;
			if (typeof value !== 'number' || Math.floor(value) !== value)
				return false;
			if (model.exceptions)
				if (model.exceptions.indexOf(value) > -1)
					return false;
			if (model.options)
				if (model.options.indexOf(value) == -1)
					return false;	
			return true;				
		},
	'string':
		(value, model) => {
			if (model.null && value === null)
				return true;
			if (typeof value !== 'string')
				return false;
			if (!model.empty && !value)
				return false;
			if (model.mask)
				if (!model.mask.test(value))
					return false;
			if (model.exceptions)
				if (model.exceptions.indexOf(value) > -1)
					return false;
			if (model.options)
				if (model.options.indexOf(value) == -1)
					return false;	
			return true;				
		},
	'array':
		(value, model) => {
			if (model.null && value === null)
				return true;
			if (!Array.isArray(value))
				return false;
			if (!model.empty && !value.length)
				return false;
			return true;				
		},
	'dict':
		(value, model) => {
			if (model.null && value === null)
				return true;
			if (typeof value !== 'object')
				return false;
			return true;				
		},
}


/* validate */
export function validate(data, model, strict) {
	const modelKeys = Object.keys(model);
	const mlen = modelKeys.length;
	if (strict) {
		const dataKeys = Object.keys(data);
		const dlen = dataKeys.length;
		for (let i = 0; i < dlen; i++)
			if (!model.hasOwnProperty(dataKeys[i]))
				return false;
	}
	for (let i = 0; i < mlen; i++) {
		const attr = model[modelKeys[i]];
		const vcheck = data.hasOwnProperty(modelKeys[i]);
		if (vcheck) {
			if (attr.type === 'object') {
				const check = validate(data[modelKeys[i]], attr.model, attr.hasOwnProperty('strict') ? attr.strict : strict);
				if (!check)
					return false;
			}
			else {
				const check = VALIDCHECK[attr.type](data[modelKeys[i]], attr);
				if (!check)
					return false;
			}
		}
		else {
			if (attr.required)
				return false;
		}
	}
	return true;
}


/* validate: model */
/*
	{
		[number] {
			required: true
		 *	type: 'number' or 'int'
			exceptions: []
			options: []
		}
		[string] {
			required: true
		 *	type: 'string'
			exceptions: []
			options: []
			empty: true
			mask: //
		}
		[array] {
			required: true
		 *	type: 'array'
			empty: true
		}
		[object] {
			required: true
		 *	type: 'object'
		 *	model: {}
			strict: false
		}
	}
	* - required field
*/
